





















































































import { Component, Vue, Watch } from 'vue-property-decorator'
import AlertaDeSistemaModule from '@/store/vuex/aplicacao/AlertaDeSistemaModule'
import NotificacaoGlobalService from '@/services/usuario/NotificacaoGlobalService'
import { primaryColor } from '@/plugins/vuetify'

@Component
export default class AlertaDeSistema extends Vue {
	set mostrarAlertaDeSistema(value: boolean) {
		AlertaDeSistemaModule.setShow(value)
	}

	get mostrarAlertaDeSistema() {
		return AlertaDeSistemaModule.mostrarAlertaDeSistema
	}

	get message() {
		return AlertaDeSistemaModule.message
	}

	get isEmergencial() {
		return this.message.tipo === 'EMERGENCIAL'
	}

	get corPrincipal() {
		return this.isEmergencial ? '#A32D2D' : primaryColor()
	}

	get rotuloLink() {
		return this.isEmergencial ? 'Ver detalhes' : 'O que há de novo'
	}

	/** Link que começa com "/" é uma tela do próprio ERP (ex.: /novidades/REL-ALM0048): abre aqui mesmo. */
	get linkInterno() {
		const link = this.message.link || ''
		return link.startsWith('/') && !link.startsWith('//')
	}

	async abrirLinkInterno() {
		const link = this.message.link
		await this.fecharAlerta()
		if (link && this.$route.fullPath !== link) this.$router.push(link).catch(() => undefined)
	}

	@Watch('mostrarAlertaDeSistema')
	onShow(show: boolean) {
		show
			? document.addEventListener('keydown', this.atalhoDeSumir)
			: document.removeEventListener('keydown', this.atalhoDeSumir)
	}

	atalhoDeSumir(event: KeyboardEvent) {
		if (event.key !== 'Escape') return
		this.fecharAlerta()
		event.preventDefault()
		event.stopPropagation()
	}

	async fecharAlerta() {
		if (!this.mostrarAlertaDeSistema) return

		await NotificacaoGlobalService.setarRecebido(this.message.id)

		this.mostrarAlertaDeSistema = false
	}
}

